videojs.addLanguage('en', {
  "POPUP_EXPORT": {
    "color": "Color",
    "language": "Language",
    "autoplay": "Autoplay",
    "from": "From",
    "permalink": "Permalink",
    "embed": "Embed",
    "french": "French",
    "english": "English",
    "italian": "Italian",
    "spanish": "Spanish"
  },
  "title_embed": "The embed link of the video",
  "play_auto": "Start play automatically",
  "default_color": "Default color of player",
  "start_play": "Start play at",
  "integration": "Integration"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_exportShare/dist/lang/en.js
// module id = 539
// module chunks = 39